import { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import "../../../../Styles/dsc.css";
import { config } from "../../../CommonUtilities/CommonUrl/CommonUrls";
import { CommonAxiosGet } from "../../../CommonUtilities/CommonAxios/CommonAxios";
import { useReactToPrint } from "react-to-print";
import { CommonPageHeading } from "../../../CommonUtilities/CommonHeading/CommonPageHeading";
import { numberToWordsIndian } from "../../../CommonUtilities/CommonFunctions/CommonFunction";
import { FaEye, FaPrint, } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export const inst_res = [
{ label: "The TET (20%) weightage has been added based on the available records.", }]
export const ScoreDetails = (props) => {
  const { resultData, from } = props;
  return (<div className="table-responsive align-center rounded-results">
    <table className='table results-table table-bordered' role="presentation">
      <thead>
        <tr className="tr-first"><th rowSpan={2} className="text-center"> POST (Applied District)<br /> (i)</th>
          <th colSpan={2} className="text-center"> EXAM SCORE</th>
          <th colSpan={2} className="text-center">TET</th>
          <th rowSpan={2} className="text-center">TOTAL SCORE<br />(vi) = (iii) + (v)</th>
          {from === 'ScoreCard' && <th rowSpan={2}>Status</th>}
        </tr>
        <tr className="tr-second"> <th>FINAL<br />(ii)</th>
          <th> NORMALIZED<br />(iii)</th>
          <th>SCORE<br />(iv)</th>
          <th> WEIGHTAGE<br />(v)</th></tr>
      </thead>
      <tbody>
        {resultData?.map((val, i) => {
          return (
            <tr key={i} >
              <td>{val?.post_name} - {val?.appl_post_dist}</td>
              <td>{val?.before_normalised_score}</td>
              <td>{val?.normalised_score}</td>
              <td>{val?.tet_marks}</td>
              <td>{val?.tet_score}</td>
              <td>{val?.total_score}  ({val?.total_score && `${numberToWordsIndian(val?.total_score)} Only`})</td>
              {from === 'ScoreCard' && <td>{val?.not_qualifing_remarks}</td>}
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>)
}
export default function ResultsNew() {
  const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails.loginData);
  const [showRstatus, setRstatus] = useState("");
  const [resultData, setResultData] = useState([]);

  const [imgData, setImgData] = useState(null)
  function getDataFunctionResult() {

    const url = `${config.url.CONTEXT_READ_URL}get-tet-score-card`;
    CommonAxiosGet(url).then((response) => {
      if (response?.data?.status === true) {
        const posts = response?.data?.data;
        setResultData(posts);
        setImgData(posts[0]?.img_path)
        setRstatus(true);
      } else {
        setImgData()
        setRstatus(false);
        setResultData([]);
      }
    })
  };
  const componentRef = useRef();
  const handleprint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `${resultData[0]?.candidate_id}_Marks`,
    pageStyle: `
               @media print {
               .person-details {
            margin-top: 5px;
            display: flex;
            align-items: flex-start;
            /* for multiline alignment */
            margin-bottom: 8px;
        }
        .label {
            width: 150px;
            /* fixed width to align colons */
            margin: 0;
            font-weight: bold;
        }
        .value {
            display: flex;
            gap: 6px;
            flex: 1;
            margin: 0;
        }
        .colon {
            min-width: 10px;
        }}
           `,
  });

  useEffect(() => {
    getDataFunctionResult()
  }, []);

  let navigate = useNavigate()
  return (
    <div>
      <CommonPageHeading heading="AP DSC-2025 Results" />
      {showRstatus === "" && <Row className="mt-4"><Col md={2}></Col>
        <Col md={8} className="text-error text-center mt-4">
          <h5 className="pt-4" style={{ color: "black" }}> Dear <span style={{ color: "brown" }}>  {loginreducer?.applicant_name}</span>, <br />Click Here &nbsp;
            <FaEye color="green" size="25px" onClick={() => { getDataFunctionResult(); }} /> &nbsp; to View your AP DSC-2025 Results.
          </h5>
        </Col><Col md={2}></Col> </Row>}
      {showRstatus === true && (
        <div className=""><center className="mb-2">
          <button className="btn btn-secondary rounded-0" variant="primary" type="button" onClick={() => {
            handleprint()
          }}>Print&nbsp; <FaPrint title="Print" style={{ fontSize: '22px' }} /> </button></center>
          <div className="Score-card-main" ref={componentRef}>
            <div className="score-page-head-part">
              <div className="score-page-head">
                <img src="img/logo-results.svg" className="img-fluid" alt="logo-results" />
                <div className="logo-text">
                  <h2>DEPARTMENT OF SCHOOL EDUCATION, ANDHRA PRADESH</h2>
                  <h3>DISTRICT SELECTION COMMITTEE - 2025</h3>
                </div>
              </div>
              <div className="score-strip">
                <p>SCORE CARD</p>
              </div>
            </div>
            <div className="total-details-body">
              <div className="personal-details">
                <div className="personal-text">
                  <div className="personal-content">
                    <p>Hall Ticket Number</p><span>:</span><h6>{resultData[0]?.candidate_id}</h6>
                  </div>
                  <div className="personal-content">
                    <p>Candidate Name</p><span>:</span><h6>{resultData[0]?.applicant_name}</h6>
                  </div>
                  <div className="personal-content">
                    <p>Father Name</p><span>:</span><h6>{resultData[0]?.father_name}</h6>
                  </div>
                  <div className="personal-content2">
                    <div className="personal-content-row">
                      <p>Date Of Birth<span>:</span></p>
                      <h6>{resultData[0]?.dob_char}</h6>
                    </div>
                    <div className="personal-content-row">
                      <p>Gender<span>:</span></p>
                      <h6>{resultData[0]?.gender}</h6>
                    </div>

                  </div>
                  <div className="personal-content1">
                    <div className="personal-content-row">
                      <p>Community<span>:</span></p>
                      <h6>{resultData[0]?.caste}</h6>
                    </div>
                    <div className="personal-content-row">
                      <p>PH Category<span>:</span></p>
                      <h6>{resultData[0]?.ph_eligible}</h6>
                    </div>
                    <div className="personal-content-row">
                      <p>EX-Servicemen<span>:</span></p>
                      <h6>{resultData[0]?.ex_service}</h6>
                    </div>
                  </div>
                </div>
                <div className="personal-image">
                  <img
                    src={`${config.url.FILE_DOWNLOAD_URL + imgData}?t=${Date.now()}`}
                    className="img-fluid photo"
                    alt="photo"
                  />
                </div>
              </div>
              <div className="table-head-results">
                <h3>SCORE CARD DETAILS</h3>
              </div>
              <ScoreDetails resultData={resultData} from="ScoreCard" />
              <div className="guidlines">
                <div className="guid-head">
                  <h4>GUIDELINES AND INSTRUCTIONS TO CANDIDATES</h4>
                </div>
                <div className="guid-body">
                  <ol className="guid-ol">
                    {inst_res?.map((item, index) => (<li key={index}>{item?.label}</li>))}
                    <li>If you have any objections regarding your TET highest score details mentioned above, you can submit valid updated information through the following link:
                      <button type="button" onClick={() => { navigate('/TetObjections') }} className="btn btn-link btn-sm">👉 Click here</button> to provide your correct TET highest score details. </li>
                    <li>Candidates need to produce the relevant certificates as per application form at the time of verification of certificates.</li>

                  </ol>
                </div>
              </div>
              <img src="../img/apdsc-water.png" className="img-fluid apdsc-water1" alt="water-mark1" />
              <img src="../img/apdsc-water.png" className="img-fluid apdsc-water2" alt="water-mark2" />
              <img src="../img/apdsc-water.png" className="img-fluid apdsc-water3" alt="water-mark3" />
              <img src="../img/apdsc-water.png" className="img-fluid apdsc-water4" alt="water-mark4" />
              <img src="../img/apdsc-water.png" className="img-fluid apdsc-water5" alt="water-mark5" />
              <img src="../img/APDSC.png" className="img-fluid apdsc" alt="apdsc" />
            </div>
          </div>
        </div>
      )}
      {showRstatus === false && (<div className="alert alert-warning"> No Data Found </div>)}
    </div>
  );
}
